/**
 * Account-deletion constants shared by every screen that talks about it.
 *
 * The number of days appears in three places that must not disagree: the member's own
 * "delete my account" confirmation, the admin's delete-user modal, and the sign-in error
 * shown to someone whose account is still inside its window. Quoting a different figure in
 * any of them is a support ticket, because the person reads it as a promise.
 *
 * Keep in sync with ACCOUNT_RECOVERY_DAYS in
 * backend/app/services/account_deletion_service.py — the backend is authoritative and
 * returns `recovery_days` on the delete response, but these screens have to state the
 * figure BEFORE the request is made.
 */

export const ACCOUNT_RECOVERY_DAYS = 7;

/** Where a deleted account holder is told to write. Mirrors SUPPORT_EMAIL in backend config. */
export const SUPPORT_EMAIL = 'support@talentfora.in';

/**
 * The API detail string both auth paths return for an account inside its recovery window
 * (session login and the Google callback). Compared rather than displayed — the copy that
 * goes with it differs per screen.
 */
export const DELETED_ACCOUNT_CODE = 'DELETED_ACCOUNT';
